import React, { useRef, useState,useEffect,useCallback } from 'react';
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import ThumbUp from '@material-ui/icons/ThumbUp';
import ThumbDown from '@material-ui/icons/ThumbDown';

import {useRedirect} from  'react-admin';
import { formatPhone } from '../references.js'
import { formatAdresse } from '../references'

  const AlertDialoOuiNoAnnule = (props,...rest)=> {
  const {withCancelButton,openFromShow,data,handleClickOpenFromShow,redirectOui}=props;
  const [open, setOpen] = useState(false);
  var agree=false;
  const redirect = useRedirect();
 
  /*
  const handleClickOpen = () => {
    setOpen(openFromShowInvoice);
  };
  */
  
 
  useEffect(() => {
    setOpen(openFromShow);
  }, [openFromShow]);


  const handleClose = () => {
    handleClickOpenFromShow(false);
    setOpen(false);
  }

  const handleAgree =() => {  
    agree=true;
    initCreateDefaultValues();
    
  }

  const handleDisagree = () => {
    initCreateDefaultValues();
    
  }
  const initCreateDefaultValues = () => {
    agree ?
        localStorage.setItem('clone', JSON.stringify({
            "nom_exp": data.order.client_exp.fullname, "tel_exp1": formatPhone(data.order.client_exp.telephone1),
            "tel_exp2": formatPhone(data.order.client_exp.telephone2), "email_exp": data.order.client_exp.email,
            "adresse_exp": formatAdresse(data.order.client_exp.adresse),
            "nom_dest": data.order.client_dest.fullname, "tel_dest1": formatPhone(data.order.client_dest.telephone1),
            "tel_dest2": formatPhone(data.order.client_dest.telephone2), "email_dest": data.order.client_dest.email,
            "adresse_dest": formatAdresse(data.order.client_dest.adresse)
        })) :

        localStorage.setItem('clone', JSON.stringify({
            "nom_exp": data.order.client_exp.fullname, "tel_exp1": formatPhone(data.order.client_exp.telephone1),
            "tel_exp2": formatPhone(data.order.client_exp.telephone2), "email_exp": data.order.client_exp.email,
            "adresse_exp": formatAdresse(data.order.client_exp.adresse)

        }));
    localStorage.setItem('fromShow', true);
    handleClose();
    redirect(redirectOui+'/create');

}

  
    return (

        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
              Création d'une autre commande pour le même expéditaire
            </DialogTitle>
            <DialogContent>
            <DialogContentText id="alert-dialog-description">
                Voulez vous garder les infos du même destinataire ?
            </DialogContentText>
            </DialogContent>
            <DialogActions>
            { withCancelButton ?
            <Button onClick={handleClose} color="primary" autoFocus >Annuler</Button> : null
            }
            <Button onClick={handleDisagree} color="primary" startIcon={<ThumbDown />}>
                Non
            </Button>
            <Button onClick={handleAgree} color="primary" autoFocus startIcon={<ThumbUp />}>
                Oui
            </Button>
        
            </DialogActions>
        </Dialog>
    );
  
}

export default AlertDialoOuiNoAnnule;
